// extracted by mini-css-extract-plugin
module.exports = {"steps-box":"Issue_steps-box__3wIr_","steps-box__steps":"Issue_steps-box__steps__azZre"};